import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';

export const Title = ({ children }) => <Box mb={2}><Typography variant={'h5'}>{children}</Typography></Box>;
Title.propTypes = {
  children: PropTypes.node.isRequired

};

export const Text = ({ children }) => <Typography variant={'body1'} paragraph>{children}</Typography>;
Text.propTypes = {
  children: PropTypes.node.isRequired
};

export const Layout = ({ title, children }) => {
  return (
    <Box pb={8} style={{ paddingTop: '68px' }}>
      <Container>
        <Typography variant='h3'>{title}</Typography>
        <Divider />
        <Box py={4}>
          {children}
        </Box>
      </Container>
    </Box>
  );
};
Layout.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};